export default "__VITE_ASSET__CKh3XB9b__"